import gql from 'graphql-tag';

/**
 * 获取礼品列表
 */
export const fetchCompRecordsDocument = gql`
  query compRecords($options: CompRecordListOptions) {
    compRecords(options: $options) {
      items {
        id
        channels {
          customFields {
            shopName
            shopLogo
          }
        }
        shippingAddress {
          fullName
          streetLine1
          streetLine2
          city
          province
          phoneNumber
          customFields {
            district
          }
        }
        description
        name
        img
        state
        price
        subscription {
          id
          expireNumberOfPeriod
          currentNumberOfPeriod
          subscriptionProducts {
            id
            product {
              name
            }
          }
        }
        type
        compLogistics {
          logisticCode
          state
        }
      }
      totalItems
    }
  }
`;

/**
 * 获取礼品详情
 */
export const fetchCompRecordsDetailDocument = gql`
  query compRecord($compRecordId: String!) {
    compRecord(compRecordId: $compRecordId) {
      id
      channels {
        customFields {
          shopName
          shopLogo
        }
      }
      shippingAddress {
        fullName
        streetLine1
        streetLine2
        city
        province
        phoneNumber
        customFields {
          district
        }
      }
      openTime
      pickTime
      description
      name
      img
      state
      price
      subscription {
        id
        expireNumberOfPeriod
        currentNumberOfPeriod
        subscriptionProducts {
          id
          product {
            name
          }
        }
      }
      type
      compLogistics {
        logisticCode
        state
        logisticInfo {
          traces {
            acceptStation
            acceptTime
          }
          name
        }
      }
    }
  }
`;

/**
 * 开启礼品
 */
export const fetchGiftDrawDocument = gql`
  mutation draw($compRecordId: String!) {
    draw(compRecordId: $compRecordId) {
      id
      description
      name
      img
      state
      price
      subscription {
        id
        subscriptionProducts {
          id
          product {
            name
          }
        }
      }
      type
    }
  }
`;

/**
 * 领取礼品
 */
export const fetchGiftPickDocument = gql`
  mutation pick($compRecordId: String!, $input: CreateAddressInput!) {
    pick(compRecordId: $compRecordId, input: $input) {
      id
      description
      name
      img
      state
      price
      subscription {
        id
        subscriptionProducts {
          id
          product {
            name
          }
        }
      }
      type
    }
  }
`;

/**
 * 获取礼品配置信息
 */
export const fetchCompActivityDocument = gql`
  query compActivity {
    compActivity {
      id
      minNumberOfPeriods
    }
  }
`;
